class Config {
    constructor() {
        this._clientId = process.env['VUE_APP_PASSPORT_CLIENT_ID'];
        this._clientName = process.env['VUE_APP_PASSPORT_CLIENT_NAME'];
    }
    /**
     * 产品 client id
     */
    set clientId(value) {
        this._clientId = value;
    }
    /**
     * 产品 client id
     */
    get clientId() {
        if (!this._clientId) {
            throw new Error('clientId is required');
        }
        return this._clientId;
    }
    /**
     * 产品 client name
     */
    set clientName(value) {
        this._clientName = value;
    }
    /**
     * 产品 client name
     */
    get clientName() {
        if (!this._clientName) {
            throw new Error('clientName is required');
        }
        return this._clientName;
    }
}
export const config = new Config;
//# sourceMappingURL=config.js.map